/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const BookmarkFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M5 2h14a1 1 0 0 1 1 1v19.14a.5.5 0 0 1-.77.43L12 18.03l-7.23 4.54a.5.5 0 0 1-.77-.43V3a1 1 0 0 1 1-1" />
  </Icon>
);
